// Google Analytics 4 event tracking utility
// Usage: trackEvent('button_click', { button_name: '探索三大版塊' });

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
};

// Convenience wrapper for button click tracking
export const trackButtonClick = (buttonName, location = '') => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: location || (typeof window !== 'undefined' ? window.location.pathname : ''),
  });
};
